import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#96c855',
                secondary: '#44732F',
                accent: '#795548',
            },
            dark: {
                primary: '#44732F',
                secondary: '#44732F',
                accent: '#795548',
            }
        }
    },
});
